import ScrollToTopOnMount from "../../components/ScrollToTopOnMount/ScrollToTopOnMount";
import ConnectWallet from "../../layouts/ConnectWallet/ConnectWallet";


const ConnectWalletPage = () => {
    return(
        <>
            <ScrollToTopOnMount />
            <ConnectWallet />
        </>
        
    )
}

export default ConnectWalletPage;